import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import { contentReport } from "../apiConfigs"
import { contentReportGradedNonGraded } from "../apiConfigs"

export const contentReportTableApi = createAsyncThunk(
    'content/report/table',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(contentReportGradedNonGraded, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const contentReportTableSlice = createSlice({
    name: 'content/report/table',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(contentReportTableApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(contentReportTableApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(contentReportTableApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const contentReportTableReducer = contentReportTableSlice.reducer